import React, { useEffect, useMemo, useState } from 'react';
import { useRecoilValue, useSetRecoilState } from "recoil";
import { currentConfiguration } from "../../../service/memory/recoil/configurationstore";
import ConfigurationConstants from "../../utils/configurationconstants";
import RichSnippetWriter from '../../articles/RichSnippetWriter';
import ListArticles from '../../articles/ListArticles';
import { Row, Col, notification } from 'antd';
import { refreshListArticle } from '../../../service/memory/recoil/listarticle';
import "./announcementcomponent.css";
import StrapiService from '../../articles/StrapiService';
import { executeIntent } from '../../utils/IntentExecutor';
import IntentType from '../../../intentexecutor/utils/IntentType';
import { useReadMemory } from '../../generic/hooks/useReadMemory';
import MemoryType from '../../../service/memory/enum/MemoryType';
import TurndownService from 'turndown';
import PrimaryButton from '../../../components/generic/buttons/PrimaryButton';
import SecondaryButton from '../../../components/generic/buttons/SecondaryButton';
import CustomModal from '../../../components/generic/custommodal/CustomModal';
import WorkforceSuggestionComponent from '../../generic/workforcesuggestion/WorkforceSuggestionComponent';
import { TextField } from '@mui/material';
import BackButton from '../../generic/elements/backbutton/BackButton';
import CustomScrollbar from '../../../components/generic/scrollbar/CustomScrollbar';
import { notifiyUser } from '../../utils/Notification';
import { strings } from '../../utils/strings';
import { useGetOrgIdentifier } from '../../generic/hooks/useGetOrgIdentifier';
import { teamList } from '../../../components/recoil/teamsRecoil';
import EditArticle from '../../careprovider/journal/EditArticle';
import apiService from '../../../service/apiservice/apiService';

const AnnouncementComponent = () => {
    const strapiService = new StrapiService();
    const [topic, setTopic] = useState("");
    const [receivedStrapiData, setReceivedStrapiData] = useState({});
    const [loading, setLoading] = useState(false);
    const configuration = useRecoilValue(currentConfiguration);
    const [isAnnouncementCreationAllowed, setAnnouncementCreationAllowed] = useState(false);
    const [resetKey, setResetKey] = useState(0);
    const [isSubmitDisabled, setIsSubmitDisabled] = useState(true)
    const setRefreshArticle = useSetRecoilState(refreshListArticle);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedUsers, setselectedUsers] = useState([]);
    const userJson = useReadMemory(MemoryType.USER);
    const teams = useRecoilValue(teamList);
    const turndownService = useMemo(() => new TurndownService({ headingStyle: "atx" }), []);
    const [body, setBody] = useState("");
    const [actionIcons, setActionIcons] = useState([]);
    const [templatesData,setTemplateData] = useState({})
    const organizationIdentifier = useGetOrgIdentifier();
    const [modalOpen, setModalOpen] = useState(false);
    const [announcementId, setAnnouncementId] = useState(null)
    const [offices, setOffices] = useState([])

    const teamIds = useMemo(() => teams.map(team => team?.id), [teams]);

    const handleDeleteAnnouncement = async (id) => {
        try {
            const response = await strapiService.deleteBlog(id);
            notifiyUser(response, strings.DELETE_ANNOUNCEMENT_SUCCESS, strings.DELETE_ANNOUNCEMENT_ERROR)
            setRefreshArticle(preValue => !preValue)
        } catch (error) {
            notification.error({
                message: "Error while deleting Announcement",
                placement: "bottomRight",
            });
        }
    }

    const handleJournalEdit = async (id) => {
        setModalOpen(true)
        setAnnouncementId(id)
    }

    useEffect(() => {
        const configurationTrendFilter = configuration[ConfigurationConstants.FEATUREACCESS_ANNOUNCEMENT_CREATE]
        setAnnouncementCreationAllowed(configurationTrendFilter?.visibility)
        const configurationAnnouncementDelete = configuration[ConfigurationConstants.FEATUREACCESS_ANNOUNCEMENT_DELETE]
        const isAnnouncementDeleteAllowed = configurationAnnouncementDelete?.visibility;
        if (isAnnouncementDeleteAllowed) {
            setActionIcons([
                {
                    label: 'Update',
                    icon: 'ARTICLE_EDIT_ICON',
                    map: 'ARTICLE_EDIT_ICON',
                    functionName: (post) => {
                        handleJournalEdit(post?.id);
                    },
                },
                {
                    label: 'Delete',
                    icon: 'ARTICLE_DELETE_ICON',
                    map: 'ARTICLE_DELETE_ICON',
                    functionName: (post) => {
                        handleDeleteAnnouncement(post?.id);
                    },
            }])
        }
    }, [configuration]);

    const generateWorkforceEntityRecommenderPayloadData = useMemo(() => {
        return {
            page: 1,
            organizationIdentifier: userJson?.organizationIdentifier,
            role: ["Volunteer"],
            teamIds: teams?.map(team => team?.id)
        };
    }, [userJson?.organizationIdentifier, teams]);

    const onWorkforceSuggestionDataChangeCallback = (data) => {
        setselectedUsers(data.selectedUsers);
    };

    const handleOnChange = (event) => {
        const inputValue = event.target.value;
        setTopic(inputValue);
        setReceivedStrapiData(prevData => ({ ...prevData, topic: inputValue }));
        const isContentEmpty = receivedStrapiData.body.trim() === "";
        setIsSubmitDisabled(inputValue === "" || isContentEmpty);
    };

    const handleStrapiDataChange = (data) => {
        setBody(turndownService.turndown(`${data.body}`))
        const modifiedData = {
            ...data,
            category: "Announcement",
            organizationIdentifier,
            topic: topic,
            teams: teams.length ?  teams.map(item => item?.id) : offices?.map(item => item?.id),
        };
        setReceivedStrapiData(modifiedData);
        const isInputEmpty = topic.trim() === "";
        if (data.body === "<p><br></p>") {
            setIsSubmitDisabled(true);
        } else {
            setIsSubmitDisabled(isInputEmpty || !data.body.trim());
        }
    };

    const uploadBlogItem = async () => {
      try {
        setLoading(true);
        const res = await strapiService.uploadBlog(receivedStrapiData);
        if (res.status === 200) {
          setTopic("");
          setReceivedStrapiData({});
          setResetKey((prevKey) => prevKey + 1);
          setRefreshArticle((prev) => !prev);
          notification.success({
            message: "Blog uploaded successfully!",
            placement: "bottomRight",
          });
        } else {
          notification.error({
            message: "Something went wrong. Please try again.",
            placement: "bottomRight",
          });
        }
      } catch (error) {
        notification.error({
          message: "Something went wrong. Please try again.",
          placement: "bottomRight",
        });
      } finally {
        setLoading(false);
      }
    };

    useEffect(() => {
      const getTemplate = async () => {
        const data = await strapiService.getTemplate("announcement", organizationIdentifier);
        const announcementTemplate = data.data[0].attributes;
        setTemplateData(announcementTemplate);
      };
      if (isModalVisible) {
        getTemplate();
      }
    }, [isModalVisible, organizationIdentifier]);

    const sendNotification = async () => {
       
        const payload = {
            creatorIdentifier: userJson?.userIdentifier,
            organizationIdentifier,
            data: {
                selectedUsers,
                selectedGroup: []
            },
            templates: {
            email: {
                subject: templatesData?.email_subject
                .replace("{givenName}", userJson?.givenName)
                .replace("{familyName}", userJson?.familyName),
                body: templatesData?.email_body
                .replace("{topic}", topic)
                .replace("{hostname}", window.location.host)
                .replace("{givenName}", userJson?.givenName)
                .replace("{familyName}", userJson?.familyName),
            },
            sms: {
                message: templatesData?.sms_message
                .replace("{givenName}", userJson?.givenName)
                .replace("{familyName}", userJson?.familyName)
                .replace("{topic}", topic),
            },
            fcm: {
                appId: templatesData?.fcm_appId,
                payLoad: {
                badge: 1,
                sound: "sound",
                body: '{"originTimestamp":1667452213355,"associatedEntities":[{"patient":"z4f6q","entityId":"ecb4736b-c470-47f1-b4e6-test2"}],"type":"form.response.update","payload":{"formUserResponse":{"templateCode":"EwtiJzwvoO","formCode":"oaf5GewCNQ","contentId":"424340443-b0a1-4273-aa5b-after2.json"},"organizationId":14,"userUID":"a01f90ba-02b1-421a-9a28-test2"},"originId":"truliacare.care.portal"}',
                notificationBody:
                    templatesData?.fcm_notification_body.replace(
                    "{body}",
                    body
                    ),
                clickAction: templatesData.clickAction,
                notification: false,
                },
                title: templatesData?.fcm_title
                .replace("{givenName}", userJson?.givenName)
                .replace("{familyName}", userJson?.familyName)
                .replace("{topic}", topic),
            },
            },
        };

        await executeIntent(IntentType.SEND_NOTIFICATION, payload, {});
    }

    const handleModalPrimaryButtonOnclick = () => {
        uploadBlogItem();
        sendNotification();
        setIsModalVisible(false);
    }

    const handleModalSecondaryButtonOnclick = () => {
        uploadBlogItem();
        setIsModalVisible(false);
    }



  useEffect(() => {
    const getOffices = async () => {
      const endpoint = "niramayafoundation/niramayaworkforce/api/v1/teams";
      const params = {
        organizationIdentifier,
      };
      const response = await apiService.get(endpoint, params);
      setOffices(response)
    };

    if (!teams || !teams?.length) {
      getOffices();
    }
  }, [organizationIdentifier, teams, teams?.length]);

    const customModelButtons = (
        <>
            <SecondaryButton buttonText={strings.SHARE_WITHOUT_NOTIFICATION} handleOnClick={handleModalSecondaryButtonOnclick} />
            <PrimaryButton buttonText={strings.SEND_NOTIFICATION} handleOnClick={handleModalPrimaryButtonOnclick} />
        </>
    )

    return (
        <>
            <section className="section-content">
                <div className="form-renderer-back-button">
                    <BackButton />
                    {userJson?.jobTitle === "Volunteer Coordinator" ? <p>Share with Community</p> : <p>Community Updates and Blogs</p>}
                </div>
                <Row>
                    {isAnnouncementCreationAllowed && (<Col xs={24} md={8}>
                        <div className='announcement-section'>
                            <div className='announcement-header-section'>
                                <label htmlFor="topicInput" className='required-mark-label'>Topic</label>
                                <TextField fullWidth
                                    label='Topic'
                                    type="text"
                                    id="topicInput"
                                    value={topic}
                                    onChange={handleOnChange}
                                    sx={{
                                        "& .MuiOutlinedInput-root": {
                                            color: "#000",
                                            "&.Mui-focused": {
                                                "& .MuiOutlinedInput-notchedOutline": {
                                                    borderColor: "var(--main-theme-color) !important",
                                                },
                                            },
                                        },
                                        "& .MuiInputLabel-outlined": {
                                            "&.Mui-focused": {
                                                color: "var(--main-theme-color) !important",
                                            },
                                        },
                                    }}
                                />
                            </div>
                            <div className='announcement-richsnippet-section'>
                                <RichSnippetWriter key={resetKey} onStrapiDataChange={handleStrapiDataChange} />
                            </div>
                            <div className='announcement-button-section'>
                                <PrimaryButton buttonText="Share" handleOnClick={() => setIsModalVisible(true)} loading={loading} buttonDisable={isSubmitDisabled} />
                            </div>
                            {isModalVisible && (
                                <CustomModal
                                    closable={true}
                                    isModalOpen={isModalVisible}
                                    footer={[customModelButtons]}
                                    closeModal={setIsModalVisible}
                                    cssClassName="modelStyleClassName"
                                    title="Notify">
                                    <WorkforceSuggestionComponent
                                        handleSelectedUserData={onWorkforceSuggestionDataChangeCallback}
                                        workforceEntityRecommenderPayloadData={generateWorkforceEntityRecommenderPayloadData}
                                        showSelectAll={true}
                                        isMultiSelect={true}
                                    />
                                </CustomModal>
                            )}
                        </div>
                    </Col>
                    )}
                    <Col xs={24} md={isAnnouncementCreationAllowed ? 16 : 24}>
                        <CustomScrollbar>
                            <ListArticles type={"Announcement"} actions={{ actionIcons }} teams={teamIds} organizationIdentifier={organizationIdentifier}/>
                        </CustomScrollbar>
                    </Col>
                </Row>
                {
                    modalOpen && <EditArticle articleId={announcementId} type={"Announcement"} modalOpen={modalOpen} setModalOpen={setModalOpen} />
                }
            </section>
        </>
    );
}

export default AnnouncementComponent;
